import { render } from "./DebugTerminal.vue?vue&type=template&id=0ac1414e&scoped=true"
import script from "./DebugTerminal.vue?vue&type=script&setup=true&lang=js"
export * from "./DebugTerminal.vue?vue&type=script&setup=true&lang=js"

import "./DebugTerminal.vue?vue&type=style&index=0&id=0ac1414e&scoped=true&lang=css"

import exportComponent from "/Volumes/Projects/wp_all_repo/wp-content/plugins/debug-log-config-tool/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ac1414e"],['__file',"resources/components/DebugTerminal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ac1414e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ac1414e', __exports__)) {
    console.log('reload')
    api.reload('0ac1414e', __exports__)
  }
  
  module.hot.accept("./DebugTerminal.vue?vue&type=template&id=0ac1414e&scoped=true", () => {
    console.log('re-render')
    api.rerender('0ac1414e', render)
  })

}


export default __exports__